var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("search-service", {
    attrs: {
      "on-select-navigate": _vm.onSelectNavigateHandler,
      results: _vm.studentServices
    },
    on: { search: _vm.onSearchHandler }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }